import GoogleTagDataLayer from "app/components/GoogleTagDataLayer/GoogleTagDataLayer";
import {
  buildEventNavigationUrl,
  storeCurrentRouteAsPrevious,
} from "app/helpers/navigationUtils";
import type { EventType } from "app/types/eventType";
import cx from "classnames";
import React from "react";
import { useHistory } from "react-router-dom";
import "./PopularEventCellMarketsTotal.scss";

type Props = {
  data: EventType;
  numberOfMarkets: number;
  toggleAlternativeLines: (...args: Array<any>) => any;
};

const PopularEventCellMarketsTotal: React.FC<Props> = props => {
  const { data, numberOfMarkets, toggleAlternativeLines } = props;
  const history = useHistory();
  if (data != null && data.marketPeriods != null) {
    return (
      <div className="popular-event-cell__markets-total" key={0}>
        <span className="popular-event-cell__markets-total__divider" />
        <GoogleTagDataLayer
          googleTagClickId={cx("", {
            "popular-event-cell__arrow--up": data.showAlternativeLines,
            "popular-event-cell__arrow--down": !data.showAlternativeLines,
          })}
          dlvEventName={"DLV-expansion-Arrow"}
        >
          <div
            className="popular-event-cell__markets-total__button"
            onClick={toggleAlternativeLines}
          >
            <div
              className={cx("", {
                "popular-event-cell__arrow--up": data.showAlternativeLines,
                "popular-event-cell__arrow--down": !data.showAlternativeLines,
              })}
            />
          </div>
        </GoogleTagDataLayer>

        <span className="popular-event-cell__markets-total__divider" />
        <GoogleTagDataLayer
          googleTagClickId={"popular-event-cell-total-markets"}
          dlvEventName={"DLV-Additional-Market"}
        >
          <span
            className="popular-event-cell__markets-total__button popular-event-cell__markets-total__button--total"
            onClick={() => {
              storeCurrentRouteAsPrevious();
              const url = buildEventNavigationUrl(data.id, data.translatedName);
              history.push(url);
            }}
          >
            +{numberOfMarkets}
          </span>
        </GoogleTagDataLayer>
      </div>
    );
  }

  return <div className="popular-event-cell__markets-total" />;
};

export default PopularEventCellMarketsTotal;
